export const getSum = (total, num) => total + parseInt(num, 10);

export const calculateCircumference = (circle) => {
  const { width } = circle.getBoundingClientRect();
  const circumference = width * Math.PI;

  return circumference;
};

export const setStrokeDash = (circle, timeLimit, time) => {
  if (!circle) return;

  const circumference = calculateCircumference(circle);
  const dasharray = (time / timeLimit) * circumference;

  // Set new dasharray
  circle.style.strokeDasharray = `${dasharray} ${circumference}`;
};

export default {
  getSum,
  calculateCircumference,
  setStrokeDash,
};
